export default function({ url, name, score, reviewCount, image, offers }) {
  const imageBlock = image ? `,
    "image": ${JSON.stringify(image)}` : ''
  const offersBlock = offers ? `,
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "${String(offers.lowPrice)}",
      "priceCurrency": "${offers.priceCurrency}"
    }` : ''
  return `{
    "@context": "https://schema.org/",
    "@type": "Product",
    "@id": "${url}#Product",
    "name": "${name.replace(/"/g, '\\"')}",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "${score}",
      "reviewCount": "${reviewCount}"
    }${imageBlock}${offersBlock}
  }`
}
